import { AppRouteProps } from "@harea/component";
import React from "react";

const PayrollListContainer = React.lazy(() => import("./container/PayrollListContainer"));

export const PayrollListRoutes = [
    {
        path: "",
        element: <PayrollListContainer />,
        title: "BSMRH.Payroll.Title",
        roles: ["PAYROLL_PROCESS"],
    },
] as Array<AppRouteProps>;
